import { render, staticRenderFns } from "./createDialog.vue?vue&type=template&id=5cc00d03&scoped=true&"
import script from "./createDialog.vue?vue&type=script&lang=js&"
export * from "./createDialog.vue?vue&type=script&lang=js&"
import style0 from "./createDialog.vue?vue&type=style&index=0&id=5cc00d03&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc00d03",
  null
  
)

export default component.exports